/* @flow */
import Entity from 'lib/Entity';

class ChatSender extends Entity {
  getName() {
    return this.get('name');
  }

  getColor() {
    return this.get('color');
  }

  getInitials() {
    return this.get('initials');
  }

  isCurrentUser() {
    // XXX remove CurrentUser from entities
    const CurrentUser = require('auth/CurrentUser').default;

    if (!CurrentUser.isSignedIn()) {
      return false;
    }

    return this.id === CurrentUser.getUserId();
  }
}

export default ChatSender;



// WEBPACK FOOTER //
// ./src/entities/ChatSender.js